import {
    IDropDownValue,
    IOffersFilterParams,
    IOfferList,
    IOffer,
    ILocalities,
} from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const OfferService = {
    async getOffersCount(): Promise<number> {
        const response = await fetch('/api/offer/GetOffersCount', {
            headers,
        });
        return await response.json();
    },
    async getAllDomainForDropdown(): Promise<IDropDownValue[]> {
        const response = await fetch('/api/offer/GetAllDomainForDropdown', {
            headers,
        });
        return await response.json();
    },
    async getAllOffers(
        offersFilterParams: IOffersFilterParams,
        signal?: AbortSignal
    ): Promise<IOfferList> {
        const response = await fetch('/api/Offer/GetAllOffers', {
            method: 'POST',
            body: JSON.stringify(offersFilterParams),
            headers,
            signal,
        });
        return response.text().then((json) => JSON.parse(json));
    },
    async getAllOffersCovid(
        offersFilterParams: IOffersFilterParams,
        signal?: AbortSignal
    ): Promise<IOfferList> {
        const response = await fetch('/api/offer/GetAllOffersCovid', {
            method: 'POST',
            body: JSON.stringify(offersFilterParams),
            headers,
            signal,
        });
        return response.text().then((json) => JSON.parse(json));
    },
    async getAllOffersForEmployer(
        officialNameList: string[]
    ): Promise<IOffer[]> {
        const response = await fetch('/api/offer/getalloffersforemployer', {
            method: 'POST',
            body: JSON.stringify(officialNameList),
            headers,
        });
        return response
            .text()
            .then((json) =>
                JSON.parse(json, (k, v) =>
                    k !== 'publishedDate' ? v : new Date(v)
                )
            );
    },
    async getAllLocalities(): Promise<ILocalities> {
        const response = await fetch('/api/offer/getalllocalities', {
            headers,
        });
        return await response.json();
    },
};
